import React from 'react';
import SEO from '../../components/modules/SEO/SEO';
import MDXProvider from '../../providers/MdxProvider';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MdxDefaultPageTemplate = _ref => {
  let {
    children,
    pageContext
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: pageContext.frontmatter.title
  }), ___EmotionJSX(MDXProvider, null, children));
};
export default MdxDefaultPageTemplate;